import React, { FC, useState, useEffect, memo, useRef } from "../../../lib/teact/teact";
import { copyTextToClipboard } from "../../../util/clipboard";
import Button from "../../ui/Button";
import { LotScreenSettings } from "../config/uiconfig";
import MessageEditor from "../message/messageEditor";
import Parser from "../restapi/parser";
import store from "../store";
import Snackbar from "../ui/snackbar";
import './tronSo.scss'
type OwnProps = {
    backToScreen: LotScreenSettings;
    onChangeScreen: (screen: LotScreenSettings) => void;
}

const TronSo: FC<OwnProps> = ({
    backToScreen,
    onChangeScreen,
}) => {
    const [state, setState] = useState({
        htmlText: "",
        errorText: "",
        htmlError: "",
        maxHeight: "15vh",
        messages: [] as string[],
        soBoSo: 5,
        tachXienMay: 4,
        showSnackbar: false,
        snackbarText: "",
    })
    function handleTextChange(text: string) {
        setState(prev => ({ ...prev, htmlText: text }))
    }
    function convertMesage() {
        let tmpElement = document.createElement("div")
        let tmp = state.htmlText.replace(/<div>/g, '<br><div>')
        tmp = tmp.replace(/<br>/g, '\n')
        tmpElement.innerHTML = tmp
        const textContent = tmpElement.innerText
        const payload = {
            body: textContent,
            date: store.getState().global.workDate,
            time: "00:00:59",
            type: 1,
            contactId: 1,
            curMien: "NAM",
            getCompactData: 0,
            getRawData: 0,
            mienCuPhapId: 2,
            tachXienMay: state.tachXienMay,
            soBoSo: state.soBoSo,
        }
        Parser.convertMessage(payload).then(result => {
            const tmp = []
            if (result.data.converted != "")
                tmp.push(result.data.converted)
            let text = result.data.html;
            if (text == "")
                text = result.data.bodyViet;
            setState({
                ...state,
                messages: tmp,
                htmlError: text,
                //htmlText:result.data.bodyViet,
            })
        }

        )
    }
    function showSnackbar(message: string) {
        setState(prev => ({ ...prev, showSnackbar: true, snackbarText: message }))
    }
    function validateNumberInput(input: any) {
        // Loại bỏ các ký tự không phải số
        input.value = input.value.replace(/[^0-9]/g, '');
    }
    function handleKeydown(e) {
        //console.log(e)
        //e.target.value
    }
    return (
        <div className=" form-main">
            <div className=" form-header border">
                <div className="form-header left-panel">
                    <Button round size="smaller" color="translucent"
                        onClick={() => onChangeScreen(backToScreen)}
                    >
                        <i className="icon icon-arrow-left" />
                    </Button>
                    <div>Bộ số xiên</div>
                    <input className="tronso-input" value={state.tachXienMay}
                        onInput={(e) => {
                            validateNumberInput(e)
                            console.log(`onInput`)
                        }}
                        onKeyDown={handleKeydown}
                        type="number"
                        step={1}
                        min={3}
                        max={4}
                        onChange={(e) => {
                            const n = Number(e.target.value)
                            if (isNaN(n)) {
                                return
                            }
                            if (n >= 3 && n <= 4)
                                setState(prev => ({ ...prev, tachXienMay: n }))
                        }}
                    ></input>
                    <div>Số bộ số</div>
                    <input className="tronso-input" value={state.soBoSo}
                        type="number"
                        step={1}
                        min={2}
                        max={1000}
                        onChange={(e) => {
                            const n = Number(e.target.value)
                            if (isNaN(n)) {
                                return
                            }
                            if (n >= 2 && n <= 1000)
                                setState(prev => ({ ...prev, soBoSo: n }))
                        }}
                    ></input>
                </div>
                <div className="form-header right-panel">
                    <Button round size="smaller" color="translucent"
                        onClick={convertMesage}
                    >
                        <i className="icon icon-play " />
                    </Button>
                </div>

            </div>
            <div className=" form-content">
                <div style={"position:relative;"}>
                    <MessageEditor onTextChange={handleTextChange}
                        onMsgTypeChange={() => { }}
                        
                        msgType={1}
                        errorTextToUser={state.errorText}
                        htmlError={state.htmlError}
                        maxHeight={state.maxHeight}
                        hidenErrorText
                        placeholder="đài chính chục 1 2 bỏ đơn vị 3 5 đá 1n , tổng chãn bỏ hàng 1,2,3  đuôi 1n"
                    ></MessageEditor>
                </div>
                {
                    state.htmlText == "" &&
                    <div className="ts-message-body">
                        ví dụ: đài chính chục 1 2 bỏ đơn vị 3 5 đá 1n , tổng chẵn bỏ hàng 1,2,3  đuôi 1n
                        từ 000 đến 400 bỏ (số 0,1,2,3,4 nối voi tổng lẻ) lo 1n
                    </div>
                }
                <div className="message-list">
                    {
                        state.messages.map((item, index) => (
                            <div className="ts-message-item">
                                <div key={index} className="ts-message-body">
                                    {item}
                                </div>
                                <div className=" right-panel">
                                    <Button round size="smaller" color="translucent"
                                        onClick={() => {
                                            copyTextToClipboard(item)
                                            showSnackbar("Đã copy tin nhắn")
                                        }}
                                    >
                                        <i className="icon icon-copy" />
                                    </Button>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
            <Snackbar
                isOpen={state.showSnackbar}
                message={state.snackbarText}
                triggerTime=""
                onClose={() => setState(prev => ({ ...prev, showSnackbar: false }))}
            ></Snackbar>
        </div>
    )
}

export default memo(TronSo)